import { InterfaceMonitoringStatusPolicy } from "constants/document/InterfaceMonitoringStatusPolicy";
import { EbisInterfaceMonitoringMaintenanceConstant } from "presentation/constant/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useEbisInterfaceMonitoringMaintenanceVM } from "presentation/hook/EbisInterfaceMonitoring/useEbisInterfaceMonitoringMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const EbisInterfaceMonitoringTitleBar: React.FC = () => {
    const [ebisInterfaceMonitoringState] = useEbisInterfaceMonitoringMaintenanceTracked();;
    const ebisInterfaceMonitoringVM = useEbisInterfaceMonitoringMaintenanceVM();
    const messageBarVM = useMessageBarVM();

    const [isLoading, setIsLoading] = useState(false);
    const { selectedRows } = ebisInterfaceMonitoringState;
    const [anaInfoState] = useANAInfoTracked();

    const { allowUpdate } = anaInfoState;

    const handleSearchClick = useCallback(() => {
        ebisInterfaceMonitoringVM.onSearchClick();
    }, [ebisInterfaceMonitoringVM]);


    const handleResentClick = useCallback(async () => {

        setIsLoading(true);
        ebisInterfaceMonitoringVM.onResend(selectedRows).then((data) => {
            if (data.success) {
                messageBarVM.showSuccess("Resend Successfully.");
                ebisInterfaceMonitoringVM.onSearch(ebisInterfaceMonitoringState.searchCriteria).then(() => {
                    setIsLoading(false);
                }).catch((error) => {
                    setIsLoading(false);
                });
            } else {
                messageBarVM.showError(data.data ?? "Resend Failed.");
                setIsLoading(false);
                return;
            }
        }).catch((error) => {
            setIsLoading(false);
            messageBarVM.showError('Resend Failed.');
        });
        setIsLoading(false);

    }, [ebisInterfaceMonitoringVM, selectedRows, messageBarVM, ebisInterfaceMonitoringState.searchCriteria]);

    const isDisable = () => {
        return selectedRows.length > 0 && selectedRows.every(entity => (entity.messageType === "SLARLN" ||
            entity.messageType === "SLARDS" ||
            entity.messageType === "CCGLIN") &&
            InterfaceMonitoringStatusPolicy.INV_SENDING_STATUS_ERROR === entity.status);
    }

    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{EbisInterfaceMonitoringMaintenanceConstant.TITLE}</HeaderTitle>
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearchClick} />

            {allowUpdate && <HPHButton label={WorkspaceConstant.Common.BUTTON_RESEND} size={'Small'} disabled={!isDisable()} theme={'Primary'} onClick={handleResentClick} />}
        </StyledAction>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {ebisInterfaceMonitoringState.forceRefresh && <></>}
    </Sidebarheader>
}

export default memo(EbisInterfaceMonitoringTitleBar);